export const SCOOTER_TRIP_ACTIVE_LOADING = "scooter-trip-active/loading";
export const SCOOTER_TRIP_ACTIVE_ERROR = "scooter-trip-active/error";
export const SCOOTER_TRIP_ACTIVE_FILTERS = "scooter-trip-active/filters";
export const SCOOTER_TRIP_ACTIVE_LIST = "scooter-trip-active/list";
export const SCOOTER_TRIP_ACTIVE_ADD = "scooter-trip-active/add";
export const SCOOTER_TRIP_ACTIVE_UPDATE = "scooter-trip-active/update";
export const SCOOTER_TRIP_ACTIVE_DELETE = "scooter-trip-active/delete";
export const SCOOTER_TRIP_ACTIVE_FINISH = "scooter-trip-active/finish";



// WEBPACK FOOTER //
// ./src/actions/scooter/trip-active/constants.js